import { html, render } from "lit-html";
import { connect as connectWithDialog } from "../connect-with-dialog";
import connectWithDataStore from "@escapio/shared/data-store/connect";
import { store } from "./DataStore";
import { translate } from "@escapio/shared/l10n/translate";
import { FilterDialog } from "./FilterDialog";

customElements.define(
	"esc-filter-dialog-button",
	connectWithDialog(
		FilterDialog,
		class extends connectWithDataStore(HTMLElement, store) {
			update(state, { filtersCount }) {
				render(
					html`<button>
						${
							filtersCount > 0
								? html`<span
										class="counter-badge counter-badge--green fa--space-after"
									>
										${filtersCount}
									</span>`
								: html`<i class="fa fa-sliders fa--space-after"></i>`
						}
						${translate("filter_bar_label_filter_summary")}
					</button>`,
					this,
				);
			}
		},
	),
);
